module.exports = __webpack_public_path__ + "img/B2.a8e433c4.png";